import projectStatusSelector from 'root/src/client/logic/project/selectors/projectStatusSelector'
import isOneOfAssigneesSelector from 'root/src/client/logic/project/selectors/isOneOfAssigneesSelector'
import includes from 'ramda/src/includes'
import { allowPinDareStatuses } from 'root/src/shared/constants/project'

export default (state, props) => {
	const isOneOfAssignees = isOneOfAssigneesSelector(state, props)
	const projectStatus = projectStatusSelector(state, props)

	return isOneOfAssignees
		&& includes(projectStatus, allowPinDareStatuses)
}
